import axios from 'axios'

const API_URLS = process.env.REACT_APP_API_URLS

export const uploadFile = async (file: any) => {
  const formData = new FormData()
  formData.append('files', file)
  try {
    const response = await axios.post(`${API_URLS}/upload`, formData)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const uploadFiles = async (files: any) => {
  const promises: Promise<any>[] = files.map(async (file: any) => {
    const formData = new FormData()
    if (!file?.type) return null
    formData.append('files', file)
    return axios.post(`${API_URLS}/upload`, formData).catch((err: any) => console.log('err', err))
  })
  try {
    const responses = await Promise.all(promises)
    const data = responses.map((response) => response?.data[0])
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}
